import React, { useEffect, useRef } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import parse from "html-react-parser";
import './Client.css';

const DscrHelocSection = ({ data }) => {
  // Ref for the container element to append the animated circles
  const containerRef = useRef(null);

  // Use effect to add animated gradient circles after component mounts
  useEffect(() => {
    if (containerRef.current) {
      // Remove any existing circles to prevent duplicates on re-render
      const existingCircles = containerRef.current.querySelectorAll('.gradient-circle');
      existingCircles.forEach(circle => circle.remove());
      
      // Create and add first gradient circle
      const firstCircle = document.createElement('div');
      firstCircle.className = 'gradient-circle circle-1';
      containerRef.current.appendChild(firstCircle);
      
      // Create and add second gradient circle
      const secondCircle = document.createElement('div');
      secondCircle.className = 'gradient-circle circle-2';
      containerRef.current.appendChild(secondCircle);
    }
  }, [data]); // Re-run if data changes

  // Safely access all the data properties with fallbacks
  const {
    title,
    description,
    subheading,
    comparisonTable
  } = data?.dscrHelocSection || {};

  // If no data is available, show a fallback or return null
  if (!data?.dscrHelocSection) {
    return null;
  }

  return (
    <div className="dscrhelocdiv" ref={containerRef}>
      <Container className="dscr-heloc-section">
        <Row>
          <Col>
            <div className="dscr-heloc-header">
              <h2>{title && parse(title)}</h2>
              <p>{description && parse(description)}</p>
            </div>
            
            <h3 className="dscr-heloc-subheading">{subheading && parse(subheading)}</h3>
            
            <div className="comparison-table-container">
              <table className="comparison-table">
                <thead>
                  <tr>
                    <th className="parameter-header">{comparisonTable?.headers?.parameter}</th>
                    <th className="heloc-header">{comparisonTable?.headers?.heloc}</th>
                    <th className="fixed-header">{comparisonTable?.headers?.fixed}</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonTable?.rows?.map((item, index) => (
                    <tr key={index}>
                      <td className="parameter-cell">{item.parameter}</td>
                      <td className="heloc-cell">
                        {/* Special handling for Wall Street Prime Index text */}
                        {item.heloc.includes("Wall Street Prime Index") ? (
                          <>
                            Tied to <b>Wall Street Prime Index</b> – ideal in falling rate environments
                          </>
                        ) : (
                          item.heloc
                        )}
                      </td>
                      <td className="fixed-cell">{item.fixed}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DscrHelocSection;